// extracted by mini-css-extract-plugin
export default {"details":"Details_details__Rv8NS","details__content":"Details_details__content__NKk61"};